import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"share"}/>
}
